<template>
  <v-row>

    <v-col cols="12" class="pt-2">
      <v-sheet
        width="100%"
        outlined 
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Habilitar edición de stands:</h3>
          </v-col>

          <v-col class="pl-4" cols="12">
            <v-switch 
              v-model="enable_edit_stand"
              :label="(enable_edit_stand)?'Habilitado':'Deshabilitado'">
            </v-switch>
            <v-sheet 
              v-if="enable_edit_stand" 
              color="success" 
              class="pa-4 white--text" 
              elevation="2" 
              rounded>
                Los stands virtuales se encuentran habilitados para su edición. Los emprendedores
                podrán realizar mas cambios sobre ellos.
            </v-sheet>

            <v-sheet 
              v-if="!enable_edit_stand" 
              color="error" 
              class="pa-4 white--text" 
              elevation="2" 
              rounded>
                Los stands virtuales se encuentran deshabilitado para su edición. Los emprendedores
                no podrán realizar mas cambios sobre ellos.
            </v-sheet>
          </v-col>

        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'editEdition', params: { id: this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        :loading="loading_update"
        color="primary"
        @click="updateEnableEditStands()"
        >
        Guardar
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_error"
      persistent
      max-width="520"
    >
      <v-card>
        <v-card-title class="text-h5">
          Advertencia
        </v-card-title>
        <v-card-text>
          <v-list v-for="error in errors" v-bind:key="error" class="ma-0">
            - {{ error }}
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="dialog_error = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
  </v-row>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'showEdition',

    data: () => ({
      loading:true,
      loading_update: false,
      dialog_error:false,
      edition:null,
      errors:[],
      
      error:false,

      enable_edit_stand: false
    }),
    methods:{
      async getEdition(){
        await axios.get('admin/editions/'+this.edition_id).then(response =>{
          this.edition = response.data.edition
          this.enable_edit_stand =  (this.edition.enable_edit_stand==1)?true:false

          this.loading=false
        }).catch(error => {
          console.log(error);
        })
      },

      async updateEnableEditStands(){

        this.loading_update=true
        this.dialog_error = false
        this.errors = []

        try {
          await axios.put('admin/editions/'+this.edition_id+'/enable-edit-stand',{
            enable_edit_stand: this.enable_edit_stand
            }).then(() =>{
              if(this.errors.length===0){
                this.$router.push({ name: 'editEdition', params: { id: this.edition_id } })
              }
            }).catch((error)=>{
              if( error.response.data.errors.length != 0){
                Object.values(error.response.data.errors).forEach(error => {
                  this.errors.push(error[0])
                })
              }

              this.loading=false
              this.dialog_error = true
            })
          } 
        catch (error) {
          //console.error(error.response.data);     // NOTE - use "error.response.data` (not "error")
          Object.values(error.response.data.errors).forEach(error => {
            this.errors.push(error[0])
          })
        }

        if(this.errors.length!=0){
          this.loading_update=false
          this.dialog_error=true
        }
      }
    },

    created(){
      this.edition_id = this.$route.params.edition_id;
      this.getEdition()
    },
  }
</script>